import { tProvidersProps } from '../../../../../../../../providers/LayoutProvider/Layout.types.ts';
import { DriveFilesActionContext } from './DriveFilesAction.constants.ts';
import { useDriveFileAction } from './DriveFilesAction.hook.tsx';

export default function DriveFilesActionProvider(props: tProvidersProps) {
  const { children } = props;
  const value = useDriveFileAction();

  return (
    <DriveFilesActionContext.Provider value={value}>
      {children}
    </DriveFilesActionContext.Provider>
  );
}
